<template>
  <div :class="['app-root', bodyClass]" id="app">
    <ValidateDomain v-if="!isValidDomain" />
    <router-view v-else />
  </div>
</template>

<script>
import ValidateDomain from "@/components/probaworkflows_base_components/ValidateDomain/ValidateDomain.vue";

export default {
  props: {
    isValidDomain: {
      type: Boolean,
      required: true,
    },
  },
  components: { ValidateDomain },
  data() {
    return {
      hostname: window.location.hostname,
    };
  },
  computed: {
    bodyClass() {
      return this.hostname.includes("dwypd.complyon") ? "dwypd-branding-domain" :
             this.hostname.includes("recruitment.dwypd.gov") ? "dwypd-branding-domain" :
             "";
    },
  },
};
</script>
